import '@shared/global.less';
import React, { useEffect } from 'react';
import { AppLocalizationProvider } from './app-localization.provider';
import Container from 'typedi';
import { API_BEARER_TOKEN_CONFIG, ApiBearerTokenConfig } from '../../shared/src/http/api-bearer-token-config';
import { TidOauthAuthService } from './tid-oauth-auth.service';

export function RootShell(props: React.PropsWithChildren<RootShellProps>): React.ReactElement {

    useEffect(() => {
        const apiBearerTokenConfig: ApiBearerTokenConfig = {
            bearerTokenProvider: window.environment.useTrimbleApiGateway
                ? () => TidOauthAuthService.getTidAccessToken() ?? ''
                : undefined,
        };
        Container.set(API_BEARER_TOKEN_CONFIG, apiBearerTokenConfig);
    }, []);

    useEffect(() => {
        document.title = props.title ?? 'Trimble Unity';
    }, [props.title]);

    return (
        <AppLocalizationProvider>
            <div className='RootShell'>
                {props.children}
            </div>
        </AppLocalizationProvider>
    );
}

export interface RootShellProps {
    title: string;
}
